module.exports = __webpack_public_path__ + "fcd3311efc571a843693985530aff64f.png";